<template>
    <div class="dialog-layer">
        <div class="mask" :class="isShow?'mask-show':'mask-hide'" @click="dialogHide"></div>
        <!--<template v-if="config.type==4">
            <div class="tc-img abs-mm">
                <router-link class="view-btn" to="/gift"
                             clstag="A05R|clk_op_tc_more"></router-link>
                <div class="tc-close-btn" clstag="A05R|clk_op_tc_exit"
                     @click="dialogHide"></div>
            </div>
        </template>-->
        <template v-if="config.type==5">
            <div class="egg-tcimg" :class="isShow?'dialog-show':'dialog-hide'">
                <div class="egg-tc-close" @click="dialogHide"></div>
                <div class="tc-close-btn" clstag="A05R|clk_op_tc_exit"
                     @click="dialogHide"></div>
            </div>
        </template>
        <template v-else-if="config.type==6">
            <div class="animate-box" :class="isShow?'dialog-show':'dialog-hide'">
                <div class="dialog-box dialog-box-size2 abs-mm">
                    <div class="dialog-top-img img-type-4"></div>
                    <div class="dialog-content column-content">
                        <h6 class="type6-title">升级攻略</h6>
                        <div class="type6-content"></div>
                        <div class="type6-subtitle">提升总鹅蛋量可快速升级哦~</div>
                    </div>
                    <div class="dialog-btn-area">
                        <div class="single-btn" @click="dialogHide">继续提鹅</div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="config.type==7">
            <div class="animate-box" :class="isShow?'dialog-show':'dialog-hide'">
                <div class="dialog-box dialog-box-size2 abs-mm">
                    <div class="dialog-top-img img-type-4"></div>
                    <div class="dialog-content column-content">
                        <h6 class="type6-title">恭喜解锁新等级</h6>
                        <div class="type7-content">
                            <div class="type7-subtitle">LV{{config.level}} {{config.levelName}}</div>
                            <div class="type7-reward">+{{config.rewardNum}} 枚鹅蛋</div>
                        </div>
                    </div>
                    <div class="dialog-btn-area">
                        <div class="single-btn font-bold" @click="dialogHide" clstag="A05R|113752">继续提鹅</div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="config.type==8">
            <div class="animate-box" :class="isShow?'dialog-show':'dialog-hide'">
                <div class="dialog-box dialog-box-size2 abs-mm">
                    <div class="dialog-top-img img-type-5"></div>
                    <div class="dialog-content column-content">
                        <div class="type8-content">
                            <div class="type8-icon"></div>
                            <div class="type8-detail font-bold">+{{config.signAward}} 枚鹅蛋</div>
                        </div>
                        <div v-if="config.newUserType!=1" class="type8-subtitle">连登<span>7天</span> 最高奖励<span>100鹅蛋</span></div>
                    </div>
                    <div class="dialog-btn-area">
                        <div class="single-btn font-bold" @click="dialogHide" clstag="A05R|12826">我知道了</div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="animate-box" :class="isShow?'dialog-show':'dialog-hide'">
                <div class="dialog-box dialog-box-size1 abs-mm">
                    <div class="dialog-top-img img-type-1" v-if="config.type==1"></div>
                    <div class="dialog-top-img img-type-2" v-if="config.type==2"></div>
                    <div class="dialog-top-img img-type-3" v-if="config.type==3"></div>
                    <div class="dialog-content">
                        <div class="change-gold-content" v-if="config.type==1">
                            <h6>
                                您将把 <span class="udc-bold">{{config.eggNum}}</span> 枚鹅蛋兑换为 <span class="udc-bold"> {{config.canChangeGold}}</span>
                                {{scoreUnits}}
                            </h6>
                            <h6>确认兑换后不能反悔哦~</h6>
                        </div>

                        <div class="get-award-content" v-if="config.type==2">
                            <h6 class="award-title">额外奖励</h6>
                            <h6 class="award-detail"><span class="udc-bold">{{config.packageNum}}</span>元白条提额包</h6>
                            <h6 class="award-sub-des">{{config.subDes}}</h6>
                        </div>

                        <div class="get-award-content" v-if="config.type==3">
                            <h6 class="award-title">额外奖励</h6>
                            <h6 class="award-detail">{{config.prizeName}}</h6>
                        </div>
                    </div>
                    <div class="dialog-btn-area">
                        <div class="btn-left" @click="dialogHide" :clstag="config.leftclstag">{{config.leftBtnText}}
                        </div>
                        <div class="btn-right" @click="rightBtnClick" :clstag="config.rightclstag" :data-qidian-ext="config.type==1?JSON.stringify({yxfk: 'ptcpbDailyWithdrawal*平台产品部_天天提鹅*鹅蛋兑换积分'}):''">
                            {{config.rightBtnText}}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    /**
     * type1:兑换鹅蛋确认弹窗
     * type2:收蛋额外奖励提额包
     * type3:收蛋额外奖励优惠券
     * type4:抽奖活动提示
     * type5:鹅蛋清零公告弹窗
     * type6:中奖攻略弹窗
     * type7:升级成功
     * type8:签到奖励
     */

    export default {
        data() {
            return {
                isShow: true
            }
        },
        props: {
            config: Object,
            scoreUnits: {
                type: String,
                default: ''
            }
        },
        mounted() {
            if (this.config.type == 8) {
                this.closeTimer = setTimeout(() => {
                    this.dialogHide();
                }, 4000)
            }
        },
        beforeDestroy() {
            if (this.closeTimer) {
                clearTimeout(this.closeTimer);
            }
        },
        methods: {
            dialogHide() {
                this.isShow = false;
                setTimeout(() => {
                    this.$emit('dialog-hide');
                    if (this.config.hideCb) {
                        this.config.hideCb()
                    }
                }, 300)
            },
            rightBtnClick() {
                if (this.config.rightBtnFn) {
                    this.config.rightBtnFn(() => {
                        this.dialogHide()
                    })
                }
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .dialog-layer {position: fixed;left: 0;top: 0;width: 100%;height: 100%; z-index: 30;
        .mask {position: absolute;left: 0;top: 0;bottom: 0;right: 0;margin: auto;width: 100%;height: 100%;background: rgba(0, 0, 0, 0.7);}
        .mask-show {animation: maskShow 0.3s 1 ease-out both;}
        .mask-hide {animation: maskHide 0.3s 1 ease-out both;}
        .animate-box {position: absolute;width: 100%;height: 100%;left: 0;top: 0;pointer-events: none}
        .dialog-box {background-color: #fff;border-radius: 0.1rem;padding: 0.2rem 0 0.25rem 0;pointer-events: auto;}
        .dialog-box-size1 {width: 3.5rem;}
        .dialog-box-size2 {width: 2.95rem;}
        .dialog-top-img {position: absolute;left: 50%;top: -0.64rem;margin-left: -1.48rem;width: 2.95rem;height: 0.65rem;@include singleBg;}
        .img-type-1 {background-image: url(#{$path}/dialog/dialog-top-1.png)}
        .img-type-2 {background-image: url(#{$path}/dialog/dialog-top-2.png)}
        .img-type-3 {background-image: url(#{$path}/dialog/dialog-top-3.png)}
        .img-type-4 {background-image: url(#{$path}/dialog/dialog-top-4.png)}
        .img-type-5 {background-image: url(#{$path}/dialog/dialog-top-5.png)}
        .dialog-content {display: flex;align-items: center;justify-content: center;}
        .column-content {flex-direction: column;}
        .dialog-btn-area {display: flex;justify-content: center;white-space: nowrap;margin-top: 0.2rem;}
        .btn-left {height: 0.5rem;background: linear-gradient(180deg, rgba(150, 133, 255, 1) 0%, rgba(120, 102, 237, 1) 100%); box-shadow: 0px 0.03rem 0.08rem 0px rgba(0, 0, 0, 0.1); border-radius: 0.3rem;line-height: 0.5rem;color: #fff;padding: 0 0.25rem;margin-right: 0.2rem;}
        .btn-right {height: 0.5rem;background: linear-gradient(180deg, rgba(255, 199, 82, 1) 0%, rgba(255, 111, 23, 1) 100%);box-shadow: 0px 0.03rem 0.08rem 0px rgba(0, 0, 0, 0.1); border-radius: 0.3rem;line-height: 0.5rem;color: #fff;padding: 0 0.25rem}
        .single-btn {width: 2.45rem;height: 0.5rem;background-image: linear-gradient(180deg, #FFC752 0%, #FF6F17 100%);
            box-shadow: 0 0.03rem 0.08rem 0 rgba(0, 0, 0, 0.10); border-radius: 0.3rem;line-height: 0.48rem;color: #fff;font-size: 0.17rem;}
        .dialog-show {animation: dialogShow 0.4s 1 linear both;}
        .dialog-hide {animation: dialogHide 0.4s 1 ease-out both;}
        //type1-兑换金币
        .change-gold-content {font-size: 0.18rem; padding-top: 0.1rem;
            span {color: #FF761C}
            }
        //type2,3-额外奖励
        .get-award-content {padding-top: 0.1rem;}
        .award-title {color: #7866ED;position: absolute;left: 0;top: 0.05rem;width: 100%;text-align: center;}
        .award-detail {font-size: 0.24rem;font-weight: bold;color: #333;}
        .award-sub-des {margin-top: 0.1rem;line-height: 1;color: #999;font-size: 0.15rem;}
        //type4:抽奖活动提示
        .tc-img {width: 3.3rem;height: 3.51rem;background-image: url(#{$path}/gift/tc.png);@include singleBg;}
        .view-btn {width: 100%;height: 0.8rem;position: absolute;left: 0;bottom: 0;}
        //type5: 鹅蛋清零公告弹窗
        .egg-tcimg {width: 3.5rem;height: 3.82rem;position: absolute;left: 50%;top: 50%;margin-left: -1.75rem;margin-top: -1.91rem;background-image: url(#{$path}/dialog/egg-tc.png);@include singleBg;}
        .egg-tc-close {width: 70%;height: 0.6rem;position: absolute;bottom: 0.1rem;left: 15%;}
        .tc-close-btn {width: 0.35rem;height: 0.35rem;position: absolute;left: 50%;bottom: -0.5rem;margin-left: -0.18rem;background-image: url(#{$path}/gift/gift-close-btn.png);@include singleBg;}
        //type6:升级攻略
        .type6-title {font-size: 0.17rem;color: #414141;font-weight: bold;}
        .type6-content {width: 2.45rem;height: 1.16rem;background-image: url(#{$path}/dialog/type6-content.png);@include singleBg;margin-top: 0.1rem;}
        .type6-subtitle {font-size: 0.14rem;color: #666;margin-top: 0.1rem;}
        //type7:升级成功
        .type7-subtitle {font-size: 0.17rem;color: #414141;font-weight: bold;}
        .type7-reward {width: 1.6rem;height: 0.42rem;background-image: linear-gradient(0deg, #7861EF 0%, #C921FD 100%);
            border: 0.02rem solid #DAA9FF;margin-top: 0.1rem;color: #fff;font-size: 0.17rem;line-height: 0.42rem;border-radius: 0.06rem;}
        //type8:每日签到
        .type8-content {width: 2.2rem;height: 0.5rem;background: rgba(241, 239, 255, 0.8); border: 0.005rem solid rgba(120, 97, 239, 0.30); border-radius: 0.02rem;box-sizing: border-box;padding: 0 0.4rem;line-height: 0.5rem;color: #2C2962;font-size: 0.16rem;text-align: left;margin-left: 0.22rem;position: relative;}
        .type8-icon {width: 0.5rem;height: 0.5rem;background-image: url(#{$path}/dialog/type8-egg-icon.png);@include singleBg;position: absolute;left: -0.25rem;top: 0;}
        .type8-subtitle {font-size: 0.14rem; margin-top: 0.1rem; color: #666;
            span {color: #7536e2;font-weight: bold;}
            }
        //animate
        @keyframes dialogShow {
            0% { opacity: 0; transform: scale3d(0.3, 0.3, 0.3); }
            35% { transform: scale3d(1.05, 1.05, 1.05); }
            60% { transform: scale3d(0.95, 0.95, 0.95); }
            100% { opacity: 1; transform: scale3d(1, 1, 1); }
            }
        @keyframes dialogHide {
            0% { opacity: 1; transform: scale3d(1, 1, 1); }
            40% { opacity: 1; transform: scale3d(1.05, 1.05, 1.05); }
            100% { opacity: 0; transform: scale3d(0, 0, 0); }
            }
        }
</style>